var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field--password position--relative"},[_c(_vm.input,{tag:"component",attrs:{"settings":{
            label: { class: _vm.settings.label.class, text: _vm.settings.label.text },
            input: Object.assign({}, {component: 'InputBasic',
                id: _vm.settings.input.name,
                type: _vm.type,
                value: '',
                isRequired: true,
                fileValidation: _vm.settings.input.fileValidation || null},
                _vm.settings.input),
            allowFilling: true
        }}}),(_vm.hasError)?_c('span',{staticClass:"field--password__eye position--absolute pointer",on:{"click":_vm.togglePassword}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }